import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import JSONbig from 'json-bigint';
import {
  adminPassword,
  adminUsername,
  barbersLimitedRegistrationApiUrl,
} from '../../config';

const response = [
  (data: any) => {
    if (typeof data === 'string') {
      try {
        data = JSONbig.parse(data);
      } catch (e) {
        console.error(e);
      }
    }
    return data;
  },
];

export const searchByCity = async (city: string): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedRegistrationApiUrl}/search`,
    params: {
      city,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const searchByPostcode = async (
  postcode: string
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedRegistrationApiUrl}/search`,
    params: {
      postcode,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const searchByLocation = async (
  latitude: number,
  longitude: number
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedRegistrationApiUrl}/search`,
    params: {
      latitude,
      longitude,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const smartSearch = async (query: string): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedRegistrationApiUrl}/search`,
    params: {
      query,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };
  return axios.request(config);
};

export const searchWithFilters = async (
  query: string,
  filters: Record<string, any>
): Promise<AxiosResponse> => {
  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `${barbersLimitedRegistrationApiUrl}/search`,
    params: {
      query,
      ...filters,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    auth: {
      username: adminUsername,
      password: adminPassword,
    },
    transformResponse: response,
  };
  return axios.request(config);
};
